import { c as _c } from "react/compiler-runtime";
import type { LiveOrderBy } from '@module/apis/client-side/live/type';
import { useFetchLiveInfiniteQuery } from '@module/queries/live/liveQueryHooks';
import { useIntersectionObserver } from '@module/utils/useIntersectionObserver';
import TimeConstants from '../../utils/item';
const LIVE_LIST_CACHE_TIME = TimeConstants.ONE_MINUTE * 3;
interface Props {
  onlyNewBj: 'Y' | 'N';
  orderBy: LiveOrderBy;
  onlyRealTimeYN?: 'Y' | 'N'; // RT 대응 - 전환 후 삭제 예정
  limit?: number;
  refetchInterval?: number | false;
}
const useLiveViewModel = t0 => {
  const $ = _c(28);
  const {
    onlyNewBj,
    orderBy,
    onlyRealTimeYN: t1,
    limit: t2,
    refetchInterval: t3
  } = t0;
  const onlyRealTimeYN = t1 === undefined ? "N" : t1;
  const limit = t2 === undefined ? 24 : t2;
  const refetchInterval = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== limit || $[1] !== onlyNewBj || $[2] !== onlyRealTimeYN || $[3] !== orderBy) {
    t4 = {
      orderBy,
      onlyNewBj,
      limit,
      onlyRealTimeYN
    };
    $[0] = limit;
    $[1] = onlyNewBj;
    $[2] = onlyRealTimeYN;
    $[3] = orderBy;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== refetchInterval) {
    t5 = {
      staleTime: LIVE_LIST_CACHE_TIME,
      gcTime: LIVE_LIST_CACHE_TIME,
      refetchInterval
    };
    $[5] = refetchInterval;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    data,
    isLoading,
    isFetching,
    hasNextPage,
    fetchNextPage,
    refetch,
    hasPreviousPage,
    fetchPreviousPage
  } = useFetchLiveInfiniteQuery(t4, t5);
  let t6;
  if ($[7] !== hasNextPage) {
    t6 = () => hasNextPage;
    $[7] = hasNextPage;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== fetchNextPage || $[10] !== t6) {
    t7 = {
      isReadyToFetch: t6,
      onInView: fetchNextPage
    };
    $[9] = fetchNextPage;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const {
    observerRef
  } = useIntersectionObserver(t7);
  let t8;
  if ($[12] !== hasPreviousPage) {
    t8 = () => hasPreviousPage;
    $[12] = hasPreviousPage;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== fetchPreviousPage) {
    t9 = () => {
      const mainContents = document.getElementById("main-contents");
      if (mainContents) {
        mainContents.scrollBy({
          top: 500
        });
      }
      fetchPreviousPage();
    };
    $[14] = fetchPreviousPage;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = {
      isReadyToFetch: t8,
      onInView: t9
    };
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const {
    observerRef: topObserverRef
  } = useIntersectionObserver(t10);
  let t11;
  if ($[19] !== data || $[20] !== fetchNextPage || $[21] !== hasNextPage || $[22] !== isFetching || $[23] !== isLoading || $[24] !== observerRef || $[25] !== refetch || $[26] !== topObserverRef) {
    t11 = {
      data,
      isLoading,
      isFetching,
      observerRef,
      refetch,
      topObserverRef,
      fetchNextPage,
      hasNextPage
    };
    $[19] = data;
    $[20] = fetchNextPage;
    $[21] = hasNextPage;
    $[22] = isFetching;
    $[23] = isLoading;
    $[24] = observerRef;
    $[25] = refetch;
    $[26] = topObserverRef;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
export default useLiveViewModel;